import '../static/Counter.css';
import React__default from "react";
import clsx from "clsx";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { StatCard } from "./StatCard.CLPZ8dPe.mjs";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { b as SectionHeader } from "./SectionHeader.VCo9GnTI.mjs";
import { b as ContentGrid } from "./ContentGrid.Bk7uBKEc.mjs";
const counterValue = `_counterValue_4a1c870`;
const customSectionHeader = `_customSectionHeader_b55ed0f`;
const _default = `_default_1cfdf82`;
const container = `_container_0a06c80`;
const styles = { counterValue, customSectionHeader, "default": _default, container };
const Counter = ({
  className,
  sectionHeader,
  counter,
  cardList,
  layout = "default",
  ...props
}) => {
  const isContainer = layout === "container";
  return /* @__PURE__ */ React__default.createElement(
    SectionWrap,
    {
      "data-ui": "counter",
      className: clsx({ [styles.containerWrap]: isContainer }, className),
      offsetTop: isContainer,
      "data-layout": layout,
      ...props
    },
    /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles[layout]) }, /* @__PURE__ */ React__default.createElement(Heading, { className: styles.counterValue, variant: "gradient", size: "5xl" }, counter), /* @__PURE__ */ React__default.createElement(
      SectionHeader,
      {
        className: styles.customSectionHeader,
        ...sectionHeader
      }
    )),
    cardList && cardList.length > 0 && !isContainer && /* @__PURE__ */ React__default.createElement(ContentGrid, { xAlign: "center", "data-testid": "contentGrid" }, cardList.map((item, i) => /* @__PURE__ */ React__default.createElement(StatCard, { key: i, ...item })))
  );
};
export {
  Counter as C
};
//# sourceMappingURL=Counter.BzFOhAWf.mjs.map
